import type { Item } from '../lib/types';
import { DataTable, type Column } from './DataTable';
import { useLightbox, ZoomThumb } from './Lightbox';

export function ItemTable({ items, atLimit, onReserve }: { items: Item[]; atLimit: boolean; onReserve: (i: Item) => void }) {
  const lb = useLightbox();
  const columns: Column<Item>[] = [
    {
      key: 'description', label: 'Item', get: (i) => i.description,
      render: (i) => (
        <span className="cell-with-thumb">
          {i.photo_ref
            ? <ZoomThumb src={i.photo_ref} className="row-thumb" caption={i.description} onOpen={lb.open} />
            : <span className="row-thumb empty">🐾</span>}
          {i.description}
        </span>
      ),
    },
    { key: 'category', label: 'Category', get: (i) => i.category_name || '—' },
    { key: 'condition', label: 'Condition', get: (i) => i.condition, render: (i) => <span className={`badge ${i.condition}`}>{i.condition}</span> },
    { key: 'location', label: 'Location', get: (i) => i.location_name || 'location TBD', render: (i) => i.location_name || <span className="badge gray">location TBD</span> },
    { key: 'available', label: 'Available', get: (i) => i.quantity_available, numeric: true, render: (i) => <span className="qty">{i.quantity_available}</span>, align: 'right' },
    // ISO date (YYYY-MM-DD) so sort/filter/CSV order chronologically; display is localized.
    { key: 'added', label: 'Date Added', get: (i) => (i.created_at || '').slice(0, 10), render: (i) => (i.created_at ? new Date(i.created_at).toLocaleDateString() : '—') },
  ];
  return (
    <>
      <DataTable
        columns={columns}
        rows={items}
        rowKey={(i) => i.id}
        exportName="shop-items"
        empty="No items match the current filters."
        actions={(i) => <button className="btn small" disabled={atLimit} onClick={() => onReserve(i)}>Reserve</button>}
      />
      {lb.node}
    </>
  );
}
